export default {
  taskRecord: {
    title: "Recompensas de Tarefas",
    loading: "Carregando...",
    empty: "Sem recompensas",
    completed: "Esta tarefa foi concluída",
    desc: "Complete tarefas para receber recompensas",
    close: "Fechar",
    add: "Adicionar",
    addEmail: "Adicionar E-mail",
    addPhoneNumber: "Adicionar Telefone",
    addBirthday: "Adicionar Data de Nascimento",
    downloadNow: "Baixar Agora",
    phone: "Número de telefone",
    email: "Endereço de e-mail",
    bank: "Cartão bancário",
    birthday: "Data de nascimento",
    download: "Baixar",
    downloadApp: "Baixar APP",
    registerBonus: "Bônus de Registro",
    firstInviteBonus: "Bônus de Primeiro Convite",
    invite: "Convidar",
    inviteNow: "Convidar Amigos",
    go: "Ir",
    receive: "Receber",
    received: "Recebido",
    task: "Tarefa",
	claimRewards: 'Reivindicar Recompensas',
    receiveSuccess: 'Recompensa recebida com sucesso',
    receiveFail: 'Falha ao receber a recompensa'
  }
};
